<template>
    <a-row :gutter="gutter" :class="{ 'stats-row--dynamic': dynamicWidth }">
        <transition-group
            name="fade-slide"
            tag="div"
            class="stats-transition-group"
            :class="{ 'stats-transition-group--dynamic': dynamicWidth, 'stats-transition-group--nowrap': nowrap }"
        >
            <a-col
                v-for="item in items"
                :key="item.key"
                :class="{ 'stats-col--dynamic': dynamicWidth }"
                :xs="24"
                :sm="item.sm || 8"
                :md="item.md || 6"
                :lg="item.lg || 3"
            >
            <transition name="fade-slide" >
                <div v-if="showTotalizadores" >
                        <a-card
                            size="small"
                            :bordered="true"
                            :class="[
                                'stat-card',
                                'clickable',
                                { 
                                    active: selectedKeys.includes(item.key),
                                    inactive: selectedKeys.length && !selectedKeys.includes(item.key)
                                }
                            ]"
                            :style="{
                                borderLeftColor: item.borderColor || '#d9d9d9'
                            }"
                            @click="$emit('click', item.key)"
                        >
                            <a-statistic
                                :value="item.value"
                                :precision="item.precision || 0"
                                :prefix="item.prefix"
                                :suffix="item.suffix"
                                :value-style="item.valueColor ? { color: item.valueColor } : {}"
                                group-separator="."
                                decimal-separator=","
                            >
                                <template #title>
                                    <div class="stat-title">
                                        <span
                                            v-if="item.icon"
                                            class="material-icons-round material-symbols-outlined  statistic-icon"
                                        >
                                            {{ item.icon }}
                                        </span>

                                        {{ item.title }}
                                    </div>
                                </template>
                            </a-statistic>

                            <div
                                v-if="item.footerText || item.footerBadge"
                                class="stat-footer"
                            >
                                <span
                                    v-if="item.footerBadge"
                                    class="stat-badge"
                                    :class="item.footerType"
                                >
                                    {{ item.footerBadge }}
                                </span>

                                <span
                                    v-if="item.footerText"
                                    class="stat-footer-text"
                                >
                                    {{ item.footerText }}
                                </span>
                            </div>
                        </a-card>
                    </div>
                </transition>
            </a-col>
        </transition-group>
    </a-row>
</template>

<script>
export default {
    name: 'StatsCards',

    props: {
        items: {
            type: Array,
            required: true,
        },

        gutter: {
            type: Array,
            default: () => [12, 12],
        },
        showTotalizadores: {
            type: Boolean,
            required: true,
        },

        selectedKeys: {
            type: Array,
            default: () => [],
        },

        dynamicWidth: {
            type: Boolean,
            default: false,
        },

        // Todos os cards numa linha só: em tela estreita a linha rola na horizontal.
        nowrap: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="scss" scoped>
.stats-transition-group {
    position: relative;
}
.stats-transition-group--dynamic {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    gap: 8px;
    width: 100%;
}
.stats-transition-group--nowrap {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 4px;
}
.stats-transition-group--nowrap .ant-col.stats-col--dynamic {
    max-width: none !important;
    min-width: 140px;
}
.ant-row.stats-row--dynamic {
    margin-left: 0 !important;
    margin-right: 0 !important;
}
.ant-col.stats-col--dynamic {
    float: none;
    width: auto !important;
    max-width: 25% !important;
    min-width: 120px;
    flex: 1 1 0;
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
    transition:
        opacity 0.35s ease,
        transform 0.35s ease;
}

.fade-slide-enter{
    opacity: 0;
    transform: translateY(-20px) scaleY(0.8);
    transform-origin: top;
}
.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-5px) scaleY(0.8);
    transform-origin: top;
}
.fade-slide-leave-active {
    pointer-events: none;
}

.fade-slide-enter-active {
    transition:
        opacity 0.35s ease,
        transform 0.35s ease;
}

.fade-slide-enter-active:nth-child(1) { transition-delay: 0ms; }
.fade-slide-enter-active:nth-child(2) { transition-delay: 50ms; }
.fade-slide-enter-active:nth-child(3) { transition-delay: 100ms; }
.fade-slide-enter-active:nth-child(4) { transition-delay: 150ms; }
.fade-slide-enter-active:nth-child(5) { transition-delay: 200ms; }
.fade-slide-enter-active:nth-child(6) { transition-delay: 250ms; }
.fade-slide-enter-active:nth-child(7) { transition-delay: 300ms; }
.fade-slide-enter-active:nth-child(8) { transition-delay: 350ms; }
.stat-card.clickable {
  cursor: pointer;
  transition: all 0.2s;
  border-width: 0;
  border-left-width: 3px !important;
  border-radius: 10px;
}

.stat-card.clickable:hover {
  transform: translateY(-2px);
}

.stat-card.clickable {
    cursor: pointer;
    transition: all 0.25s ease;
    border-width: 0;
    border-left-width: 3px !important;
    border-radius: 10px;
}

.stat-card.active {

    transform: translateY(-2px);
}


.statistic-icon {
  margin-right: 6px;
}

.stat-col {
    display: flex;
}

.stat-card {
    width: 100%;
    height: 100%;
}

.stat-card :deep(.ant-card-body) {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.stat-card {
    transition: all 0.25s ease;
}

.stat-card.inactive:not(:hover) {
    opacity: 0.45;
    filter: grayscale(0.3);
    border-left-color: #e0e0e0 !important;
}
.stat-card.inactive:hover :deep(.stat-title),
.stat-card.inactive:hover :deep(.ant-statistic-content-value),
.stat-card.inactive:hover :deep(.ant-statistic-content-suffix),
.stat-card.inactive:hover :deep(.stat-footer),
.stat-card.inactive:hover :deep(.stat-footer-text),
.stat-card.inactive:hover :deep(.stat-badge),
.stat-card.inactive:hover :deep(.statistic-icon) {
    color: inherit !important;
}
.stat-card.inactive :deep(.stat-title) {
    color: #8c8c8c;
}

.stat-card.inactive :deep(.ant-statistic-content-value) {
    color: #8c8c8c !important;
}

.stat-card.inactive :deep(.ant-statistic-content-suffix) {
    color: #8c8c8c !important;
}

.stat-card.inactive :deep(.statistic-icon) {
    color: #bfbfbf;
}

.stat-card.inactive :deep(.stat-footer),
.stat-card.inactive :deep(.stat-footer-text),
.stat-card.inactive :deep(.stat-badge) {
    color: #bfbfbf !important;
}

.stat-card.inactive:hover {
    opacity: 0.75;
    filter: grayscale(0);
}

.stat-card.inactive:hover :deep(.ant-statistic-content-value),
.stat-card.inactive:hover :deep(.stat-title) {
    color: #595959;
}
.stat-title {
    white-space: nowrap;
}
.stat-footer {
    padding-top: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.7rem;
    color: #8c8c8c;
    min-height: 32px;
}
.stat-footer-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 0;
    text-wrap: nowrap;
}

.stat-footer-placeholder {
    visibility: hidden;
}

.stat-badge {
    display: none;
    align-items: center;
    justify-content: center;
    padding: 2px 6px;
    border-radius: 999px;
    font-size: 0.68rem;
    font-weight: 600;
    white-space: nowrap;
    
}

.stat-badge.danger {
    background: #fff1f0;
    color: #cf1322;
}
</style>